export const THEMES = {
	default: "default",
	thalia: "thalia",
} as const;

export type ThemeName = keyof typeof THEMES;

export function applyTheme(themeName: ThemeName) {
	const root = document.documentElement;

	Object.values(THEMES).forEach((theme) => {
		if (theme !== "default") {
			root.classList.remove(`theme-${theme}`);
		}
	});

	if (themeName !== "default") {
		root.classList.add(`theme-${themeName}`);
	}
}

export function getCurrentTheme(): ThemeName {
	const root = document.documentElement;

	for (const [key, value] of Object.entries(THEMES)) {
		if (value !== "default" && root.classList.contains(`theme-${value}`)) {
			return key as ThemeName;
		}
	}

	return "default";
}

export function saveThemeToStorage(themeName: ThemeName) {
	if (typeof window === "undefined") return;
	localStorage.setItem("app-theme", themeName);
}

export function initializeTheme(): ThemeName {
	if (typeof window === "undefined") return "default";

	const stored = localStorage.getItem("app-theme") as ThemeName | null;
	if (stored && stored in THEMES) {
		applyTheme(stored);
		return stored;
	}

	return "default";
}
